import { useContext } from 'react';

import { AttachmentContext } from './context';

const useAttachment = () => useContext(AttachmentContext);

export default useAttachment;

